import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSWR from 'swr';
import { TransformationExecution } from '../../../../../../../typings/TransformationExecution.interface';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { TransformationExecutionsFiltersProps } from '../../../../typings/TransformationExecution.interface';
import Badge from '../../../common/base/Badge';
import Chip from '../../../common/base/Chip';
import Text from '../../../common/base/Text';
import DisplayDate from '../../../common/DisplayDate';
import Table from '../../../common/Table/Table';
import { GlobalContext } from '../../../contexts/GlobalContext';
import useTransformationExecutionsList from '../../../hooks/useTransformationExecutionsList';
const TransformationExecutionsList: React.FC<{
  transformation_id: string;
  selected_execution_id?: string;
  filters: TransformationExecutionsFiltersProps;
  onPaginationChanged?(filters: object): void;
  onExecutionSelected(execution_id: string): void;
  onEdit(exeuction: TransformationExecution): void;
}> = t0 => {
  const $ = _c(29);
  const {
    transformation_id,
    selected_execution_id,
    onExecutionSelected,
    onPaginationChanged,
    filters
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    executions,
    fetched,
    count,
    next,
    prev
  } = useTransformationExecutionsList(transformation_id, filters);
  let t1;
  let t2;
  let unique_webhook_ids;
  if ($[0] !== executions) {
    unique_webhook_ids = executions ? Array.from(new Set(executions.map(_temp))).sort() : [];
    t1 = useSWR;
    t2 = APIMethodKeys.webhooks.list(unique_webhook_ids.length > 0 ? {
      id: unique_webhook_ids
    } : {
      limit: 1
    });
    $[0] = executions;
    $[1] = t1;
    $[2] = t2;
    $[3] = unique_webhook_ids;
  } else {
    t1 = $[1];
    t2 = $[2];
    unique_webhook_ids = $[3];
  }
  let t3;
  if ($[4] !== HookdeckAPI.webhooks || $[5] !== unique_webhook_ids) {
    t3 = () => HookdeckAPI.webhooks.list(unique_webhook_ids.length > 0 ? {
      id: unique_webhook_ids
    } : {
      limit: 1
    });
    $[4] = HookdeckAPI.webhooks;
    $[5] = unique_webhook_ids;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: webhooks
  } = t1(t2, t3);
  const loading = !fetched || !webhooks;
  let t4;
  if ($[7] !== webhooks) {
    t4 = webhooks && webhooks.models.reduce(_temp2, {});
    $[7] = webhooks;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const webhooks_by_id = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["Executed At", "Log Level", "Connection"];
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const headers = t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [{
      min: 150,
      max: 150
    }, {
      min: 100,
      max: 100
    }, {
      min: 100
    }];
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const widths = t6;
  let t7;
  if ($[11] !== executions || $[12] !== loading || $[13] !== selected_execution_id || $[14] !== webhooks_by_id) {
    t7 = loading ? [] : executions.reduce((rows, log) => [...rows, {
      id: log.id,
      selected: selected_execution_id === log.id,
      highlighted: selected_execution_id === log.id,
      fields: [<DisplayDate key={log.id} date={log.created_at} show_timezone={false} />, <Badge key={log.id} danger={log.log_level === "fatal" || log.log_level === "error"} warning={log.log_level === "warn"} primary={log.log_level === "info" || log.log_level === "debug"} success={!log.log_level} subtle={true}>{log.log_level?.toUpperCase() || "OK"}</Badge>, !webhooks_by_id || !webhooks_by_id?.[log.webhook_id] ? <Text size="s" muted={true}>Connection Deleted</Text> : <Chip to={`/connections/${log.webhook_id}`} outline={true} mono={true} label={webhooks_by_id[log.webhook_id].full_name} />]
    }], []);
    $[11] = executions;
    $[12] = loading;
    $[13] = selected_execution_id;
    $[14] = webhooks_by_id;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const rows_0 = t7;
  let t8;
  if ($[16] !== next || $[17] !== onPaginationChanged) {
    t8 = onPaginationChanged && next ? () => onPaginationChanged({
      next,
      prev: undefined
    }) : undefined;
    $[16] = next;
    $[17] = onPaginationChanged;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== onPaginationChanged || $[20] !== prev) {
    t9 = onPaginationChanged && prev ? () => onPaginationChanged({
      prev,
      next: undefined
    }) : undefined;
    $[19] = onPaginationChanged;
    $[20] = prev;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== count || $[23] !== loading || $[24] !== onExecutionSelected || $[25] !== rows_0 || $[26] !== t8 || $[27] !== t9) {
    t10 = <Table fill={true} top_offset={106} headers={headers} widths={widths} rows={rows_0} loading={loading} onRowSelected={onExecutionSelected} onNextPage={t8} onPreviousPage={t9} current_count={count} />;
    $[22] = count;
    $[23] = loading;
    $[24] = onExecutionSelected;
    $[25] = rows_0;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
export default TransformationExecutionsList;
function _temp(event) {
  return event.webhook_id;
}
function _temp2(object, webhook) {
  return {
    ...object,
    [webhook.id]: webhook
  };
}